//TODO move to oy/types

import { OyResponse } from '@oy/types';
import { BUSINESS_PAYMENT_PREFIX } from 'src/clients';
import { PaginationRs } from 'src/models/Common';

export const ACCOUNT_STATEMENT_URL = `${BUSINESS_PAYMENT_PREFIX}/reports/account-statement/search`;

export type AccountStatementData = {
  adminFee: number;
  amount: number;
  balanceAfter: number;
  balanceBefore: number;
  balanceFlow: number;
  createBy: string;
  created: string;
  transactionCreated: string;
  description: string;
  id: string;
  internalTxNote: string;
  lastUpdated: string;
  lastUpdatedBy: string;
  partnerTxId: string;
  pendingBalanceAfter: string;
  pendingBalanceBefore: string;
  freezeBalanceAfter: string;
  freezeBalanceBefore: string;
  ppnTax: number;
  recipientAccountNumber: string;
  recordFlag: string | null; // not sure need to ask backend
  serviceFeeAfter: number;
  serviceFeeBefore: number;
  serviceFeePaid: number;
  status: string; // could be enum
  transactionFeePaid: number;
  transferAmount: number;
  txId: string;
  txNote: string;
  txProduct: string;
  txStatus: string; // could be enum
  txType: string; // could be enum
  usedOverdraftAfter: number;
  usedOverdraftBefore: number;
  username: string;
};

export type GetAccountStatementRs = OyResponse<
  PaginationRs<AccountStatementData[]>
>;
